import script from "./PLLSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PLLSection.vue?vue&type=script&setup=true&lang=js"

import "./PLLSection.vue?vue&type=style&index=0&id=51a20372&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51a20372"]])

export default __exports__